<template>
  <div>
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="100px"
             class="demo-ruleForm">
      <el-row style="margin-bottom:10px;"
              :gutter="20">
        <el-col :span="8">
          <el-form-item label="标题:"
                        prop="title">
            <el-input v-model="ruleForm.title"
                      placeholder="必填，2-40个字"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="邀约类型:"
                        prop="appointUids">
            <el-radio-group v-model="ruleForm.appointUids"
                            :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                            size="small">
              <el-radio-button label="0">公开需求</el-radio-button>
              <el-radio-button label="1">定向需求</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="邀约状态:"
                        prop="status">
            <el-radio-group v-model="ruleForm.status"
                            size="small"
                            :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'">
              <el-radio-button label="0">关闭</el-radio-button>
              <el-radio-button label="1">开启</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="ruleForm.appointUids === '1'"
              style="margin-bottom:10px;"
              :gutter="20">
        <el-col :span="12">
          <el-form-item label="邀约用户:">
            <el-input disabled
                      v-model="ruleForm.appointUidsName"
                      placeholder="请选择用户"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-button @click="openDialog">选择用户（不超过10人）</el-button>
        </el-col>
        <el-col :span="6">
          <el-button @click="importUser">导入常用用户</el-button>
        </el-col>
      </el-row>

      <el-form-item label="用图需求描述:"
                    prop="desc">
        <!-- <quill-editor
          v-model="content"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)"
        ></quill-editor>-->

        <div id="websiteEditorElem"
             style="height:300px;background: #ffffff;"></div>
      </el-form-item>
    </el-form>

    <div class="bottombtn">
      <div class="btn">
        <el-button @click="closeForm">取消</el-button>
        <el-button @click="submitForm('ruleForm')"
                   v-if="!isClick"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">确认</el-button>
        <el-button disabled
                   v-else
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">确认</el-button>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible"
               width="40%"
               :before-close="handleClose">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>选择用户</div>
      </div>
      <div>
        <el-transfer v-model="transferValue"
                     :titles="['所有用户', '已选择用户']"
                     :data="transferData"
                     :left-default-checked="[]"></el-transfer>
      </div>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="chooseUser">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addQuillTitle } from "@/plugins/quill-title.js";
import E from "wangeditor";
import { listUser, getUser } from "@/api/user";
import getMD5 from "@/plugins/getMD5";
import { picPrefix } from "@/constants/piccommon";
import SparkMD5 from "spark-md5";
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
export default {
  props: {
    ruleForm: Object
  },
  watch: {
    ruleForm: {
      //深度监听，可监听到对象、数组的变化
      handler (newV, oldV) {
        // do something, 可使用this
        // console.log(newV);
      },
      deep: true
    }
  },
  data () {
    return {
      isClick: false,
      picPrefix,
      picname: 1,
      dialogVisible: false,
      transferData: [],
      transferValue: [],
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          { min: 2, max: 40, message: "长度在 2 到 40 个字符", trigger: "blur" }
        ],
        appointUids: [
          { required: true, message: "请选择邀约类型", trigger: "change" }
        ],
        status: [
          { required: true, message: "请选择邀约状态", trigger: "change" }
        ]
      },

      phoneEditor: "",

      content: ``,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], //不需要设置值，直接写名字
            [{ header: 1 }, { header: 2 }], //需要设置值
            [{ script: "sub" }, { script: "super" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ color: [] }, { background: [] }] // 字体颜色，字体背景颜色
          ]
        }
      }
    };
  },
  methods: {
    importUser () {
      let appointUidsId = sessionStorage.getItem("appointUids");
      let appointUidsName = sessionStorage.getItem("appointUidsName");

      if (appointUidsId) {
        this.ruleForm.appointUidsId = appointUidsId;
        this.ruleForm.appointUidsName = appointUidsName;
        let aUI = [];
        for (
          let i = 0;
          i < this.ruleForm.appointUidsId.split(",").length;
          i++
        ) {
          aUI.push(parseInt(this.ruleForm.appointUidsId.split(",")[i]));
        }
        this.transferValue = aUI;
        this.$message.success("导入成功！");

      } else {
        this.$message("暂无数据导入");
      }
      // console.log(this.ruleForm.appointUidsName)
    },

    submitForm (formName) {
      // if(this.ruleForm.appointUids === '1'){
      //       this.ruleForm.appointUids = ''
      //       if(this.transferValue.length === 0){
      //         this.ruleForm.appointUids = this.ruleForm.appointUidsId
      //       }else{

      //         for (let i = 0; i < this.transferValue.length; i++) {
      //           if( i !== this.transferValue.length - 1){
      //             this.ruleForm.appointUids += this.transferValue[i] +','
      //           }else{
      //             this.ruleForm.appointUids += this.transferValue[i]
      //           }
      //         }

      //       }

      //     }

      // console.log(this.phoneEditor.txt.html())
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isClick = true
          setTimeout(() => {
            this.isClick = false
          }, 2000);


          this.ruleForm.content = this.phoneEditor.txt.html();
          if (this.ruleForm.appointUids === "1") {
            // console.log(this.transferValue)
            if (this.transferValue.length === 0) {
              this.$message.error('请选择用户！')
              return false
            }
            this.ruleForm.appointUids = "";
            if (this.transferValue.length === 0) {
              this.ruleForm.appointUids = this.ruleForm.appointUidsId;
            } else {
              for (let i = 0; i < this.transferValue.length; i++) {
                if (i !== this.transferValue.length - 1) {
                  this.ruleForm.appointUids += this.transferValue[i] + ",";
                } else {
                  this.ruleForm.appointUids += this.transferValue[i];
                }
              }
            }
          }


          // console.log(this.ruleForm.appointUids !== "0")


          if (!this.ruleForm.hasOwnProperty('id') && this.ruleForm.appointUids !== "0") {
            sessionStorage.setItem("appointUids", this.ruleForm.appointUids);
            sessionStorage.setItem(
              "appointUidsName",
              this.ruleForm.appointUidsName
            );
          }


          this.$emit("submitForm", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    closeForm () {
      this.$emit("closeForm");
    },

    openDialog () {
      if (typeof this.ruleForm.appointUidsId === "string") {
        let aUI = [];
        for (
          let i = 0;
          i < this.ruleForm.appointUidsId.split(",").length;
          i++
        ) {
          aUI.push(parseInt(this.ruleForm.appointUidsId.split(",")[i]));
        }
        this.transferValue = aUI;
      } else if (this.ruleForm.appointUidsId instanceof Array) {
        let aUI = [];
        for (let i = 0; i < this.ruleForm.appointUidsId.length; i++) {
          aUI.push(parseInt(this.ruleForm.appointUidsId[i]));
        }
        this.transferValue = aUI;
      }
      // if(this.ruleForm.appointUidsName){
      //   let aUI = []
      //   for (let i = 0; i < this.ruleForm.appointUidsName.split(';').length; i++) {
      //     this.getUserAsync(parseInt(this.ruleForm.appointUidsName.split(';')[i]))
      //   }
      //   this.transferValue = aUI
      // }

      setTimeout(() => {
        this.dialogVisible = true;
      }, 300);
    },
    handleClose () {
      this.dialogVisible = false;
      // this.transferValue = [];
      this.transferData = [];
      this.listUserAsync();
    },

    //确认选中的用户
    chooseUser () {
      this.ruleForm.appointUidsName = "";

      if (isNaN(this.transferValue[0])) {
        this.transferValue.shift();
      }
      //

      for (let i = 0; i < this.transferValue.length; i++) {
        this.getUserAsync(this.transferValue[i]);
      }
      this.ruleForm.appointUidsId = this.transferValue;
      // console.log(this.transferValue)
      setTimeout(() => {
        this.dialogVisible = false;
      }, 1000);
    },

    //分片上传
    async fragmentation (val, blob, bytesPerPiece, totalPieces, insert) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = blob.name + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };

        if (index < totalPieces) {
          // console.log('分片次数',index)
          await this.uploadPicChunkAsync(params, formData, blob, insert);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: blob.name,
            hash: val
          };
          await this.uploadPicChunkMergeAsync(params, blob, insert);
        }
        start = end;
        index++;
      }
    },

    //获取用户列表
    async listUserAsync (val) {
      let { status, data, message, errors } = await listUser(val);
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].userType !== 1) {
            this.transferData.push({
              key: data[i].id,
              label: data[i].name
            });
          }

        }
      }
    },

    //查询用户
    async getUserAsync (val) {
      let { status, data, message, errors } = await getUser(val);
      if (status) {
        this.ruleForm.appointUidsName += data.name + ";";
        // console.log(this.ruleForm.appointUidsName)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //常规文件上传
    async uploadPicAsync (val, insert) {
      let { status, data, message } = await uploadPic(val);
      if (status) {
        let src = picPrefix + data.savepath
        insert(src)
        this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
      }
    },

    //分片上传接口第一步
    async uploadPicChunkAsync (params, val, blob, insert) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        console.log("分片第一步");
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsync (params, blob, insert) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (!status) {
        let fd = new FormData();
        fd.append("file", blob);
        this.uploadPicAsync(fd, insert);
      } else {
        let src = picPrefix + data.savepath
        insert(src)
        this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
      }
    },
    //通过md5查询图片
    async getFileInfoByHashAsync (val, blob, b, t, insert) {
      let { status, data, message } = await getFileInfoByHash(val);
      if (!status) {
        this.fragmentation(val, blob, b, t, insert);
      } else {
        let src = picPrefix + data.savepath
        insert(src)
        this.phoneEditor.txt.html(this.phoneEditor.txt.html().replace('<i style="font-size:24px" class="el-icon-loading"></i>', ''))
      }
    }
  },
  created () {
    this.listUserAsync({ pageSize: 10000 });

    this.ruleForm.status = this.ruleForm.status.toString()
    // this.listUserAsync()
    this.transferValue = this.ruleForm.appointUidsId.split(',')
  },
  mounted () {
    var that = this;
    var spark = new SparkMD5();
    this.phoneEditor = new E("#websiteEditorElem");
    // 上传图片到服务器，base64形式
    // this.phoneEditor.customConfig.uploadImgShowBase64 = true;
    // 隐藏网络图片
    this.phoneEditor.customConfig.showLinkImg = false;

    // 自定义菜单配置
    this.phoneEditor.customConfig.menus = [
      "head", // 标题
      "bold", // 粗体
      "fontSize", // 字号
      "fontName", // 字体
      "italic", // 斜体
      "underline", // 下划线
      "foreColor", // 文字颜色
      "backColor", // 背景颜色
      // 'link',  // 插入链接
      // 'list',  // 列表
      "justify", // 对齐方式
      "quote", // 引用
      "image", // 插入图片
      // 'table',  // 表格
      // 'video',  // 插入视频
      // 'code',  // 插入代码
      "undo", // 撤销
      "redo" // 重复
    ];

    // 配置服务器端地址
    // this.phoneEditor.customConfig.uploadImgServer = 'http://cdp-local.test.routeryuncs.com/file/uploadPic'

    // 将图片大小限制为 50M
    this.phoneEditor.customConfig.uploadImgMaxSize = 50 * 1024 * 1024

    // 限制一次最多上传 10 张图片
    this.phoneEditor.customConfig.uploadImgMaxLength = 10

    //上传图片事件
    this.phoneEditor.customConfig.customUploadImg = function (files, insert) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;

      let icon = '<i style="font-size:24px" class="el-icon-loading"></i>'
      that.phoneEditor.txt.html(that.phoneEditor.txt.html() + icon)

      files.forEach(item => {
        // var reader = new FileReader();
        // reader.readAsDataURL(item);
        // reader.onload = function(e) {
        //   insert(this.result);
        // };

        if (item.size > 560000) {
          bytesPerPiece = 202020;
        } else {
          bytesPerPiece = 9888;
        }
        getMD5(item, md5 => {
          that.getFileInfoByHashAsync(
            md5,
            item,
            bytesPerPiece,
            totalPieces,
            insert
          );
        })
        // that.$nextTick(() => {
        //   let fd = new FormData();
        //   fd.append("file", item);
        //   that.uploadPicAsync(fd);
        // });

      });

      // files.forEach(item => {
      //   that.$nextTick(()=>{
      //     let fd = new FormData();
      //     fd.append("file", item); // 上传的文件： 键名，键值
      //     axios.post("https://jsonplaceholder.typicode.com/posts/",{file:fd}
      //    )
      //     .then(res => {
      //       console.log(res)
      //     })
      //     .catch(res => {
      //       console.log(res);
      //     });
      //   })

      // 以下是上传图片的接口，视情况而更改就可以啦
      // 上传地址的接口名(fd).then(data => {
      //   // 上传代码返回结果之后，将图片插入到编辑器中
      //   insert(data.url);
      // });
      // });
    };

    // this.phoneEditor.customConfig.uploadImgHooks = {
    //   before: function (xhr, editor, files) {
    //       // 图片上传之前触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

    //       console.log(files)

    //       // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
    //       // return {
    //       //     prevent: true,
    //       //     msg: '放弃上传'
    //       // }
    //   },
    //   success: function (xhr, editor, result) {
    //       // 图片上传并返回结果，图片插入成功之后触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
    //   },
    //   fail: function (xhr, editor, result) {
    //       // 图片上传并返回结果，但图片插入错误时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
    //   },
    //   error: function (xhr, editor) {
    //       // 图片上传出错时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
    //   },
    //   timeout: function (xhr, editor) {
    //       // 图片上传超时时触发
    //       // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
    //   },

    //   // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
    //   // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
    //   customInsert: function (insertImg, result, editor) {
    //       // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
    //       // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

    //       // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
    //       var url = result.files['image.png']
    //       insertImg(url)

    //       // result 必须是一个 JSON 格式字符串！！！否则报错
    //   }
    // }

    // 创建一个富文本编辑器
    this.phoneEditor.create();
    // 富文本内容
    this.phoneEditor.txt.html(this.ruleForm.content);
  }
};
</script>

<style lang="scss" scoped>
@import "@/constants/elHeader.scss";
.quill-editor ::v-deep .ql-container {
  height: 240px !important;
}
// #websiteEditorElem ::v-deep .w-e-menu

#websiteEditorElem ::v-deep .w-e-text-container {
  z-index: 3 !important;
}
#websiteEditorElem ::v-deep .w-e-menu {
  z-index: 5 !important;
}
// #websiteEditorElem ::v-deep .w-e-text-container,
// #websiteEditorElem ::v-deep .w-e-toolbar
// {
//   z-index: 1999 !important;
// }

.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 2px;
  // z-index: 2002;
  // top: 0;
  z-index: 7;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn ::v-deep .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn ::v-deep .el-button--primary {
  background-color: #185ed3;
}

::v-deep .el-transfer {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-form-item__label {
  font-weight: 600;
}
::v-deep .el-dialog__wrapper {
  z-index: 10003 !important;
}
::v-deep .el-button--primary .is-disabled:hover {
  background-color: #3CB035;
}
::v-deep.el-button
  .el-button--primary
  .el-button--small
  .is-disabled
  .el-transfer__button {
  background-color: #3CB035;
}
::v-deep .is-checked .el-checkbox__label {
  color: #606266;
}
::v-deep .is-checked .el-checkbox__inner {
  background-color: #3CB035;
  border-color: #3CB035;
}
::v-deep .is-indeterminate .el-checkbox__inner {
  background-color: #3CB035;
}
::v-deep .el-button--primary {
  background-color: #3CB035;
}
</style>
